import { useState, useEffect } from 'react';
import { Button } from '../input';
import { Modal } from '../modal';
import { Copy } from '../copy';

export const DisplayPrompt = ({ job }) => {
  const [isLong, setIsLong] = useState();
  const [show, setShow] = useState();
  const [cutoff] = useState(500);

  useEffect(() => {
    setIsLong(job?.args?.prompt && job?.args?.prompt.length > cutoff);
  }, [job?.args?.prompt, cutoff]);

  const toggle = () => setShow(!show);
  const clip = isLong && !show;
  const p = job?.params?.prompt || '';
  const prompt = p.substring(0, clip ? cutoff : p.length) + (clip ? '...' : '');

  return (
    <div
      style={{
        fontSize: 14,
        padding: '10px 12px',
        borderRadius: 8,
        border: '1px solid #d3d3d3',
        borderTop: 0,
        borderLeft: 0,
        borderRight: 0,
      }}
    >
      <Copy value={p} onlyCheck innerStyle={{ width: '100%', whiteSpace: 'pre-line' }}>
        {prompt}
        {isLong && (
          <div style={{ position: 'sticky', bottom: 0, background: 'white', ...(show ? { padding: '5px 0' } : {}) }}>
            <Button small trans gray onClick={toggle}>
              Show {show ? 'less' : 'more'}
            </Button>
          </div>
        )}
      </Copy>
    </div>
  );
};

// job?.args?.prompt && (
//   <Modal title="Prompt">
//     <div
//     style={{
//       fontSize: 14,
//       padding: '10px 12px',
//       borderRadius: 8,
//       border: '1px solid #d3d3d3',
//       borderTop: 0,
//       borderLeft: 0,
//       borderRight: 0,
//     }}
//   >
//     <div
//       style={{
//              display: '-webkit-box',
//              WebkitLineClamp: 3,
//              WebkitBoxOrient: 'vertical',
//              overflow: 'hidden',
//              }}
//       >
//       {job.args.prompt}
//     </div>
//     </div>

//     <div style={{ width: '100%', maxWidth: 680 }}>
//       <Copy value={job.args.prompt}>{job.args.prompt}</Copy>
//     </div>
//   </Modal>
// );
